var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import assert from 'assert';
import * as _ from 'lodash';
import { RPChatsAPI } from '../RPChatsAPI';
class RPChats {
    constructor(config) {
        this.config = config;
        if (!_.isString(config.host) || _.isEmpty(config.host)) {
            throw new Error('Invalid configuration, host must be not empty string');
        }
        if (!_.isNumber(config.port) || config.port <= 0 || config.port >= 65535) {
            throw new Error('Invalid configuration, port must be valid integer');
        }
        if (!_.isString(config.token) || _.isEmpty(config.token)) {
            throw new Error('Invalid configuration, token must be not empty string');
        }
        if (!_.isNumber(config.userId)) {
            throw new Error('Invalid configuration, userId must be valid integer');
        }
        this._rpChatsAPI = new RPChatsAPI(this.config);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._rpChatsAPI.init();
        });
    }
    deinit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._rpChatsAPI.deinit();
        });
    }
    onError(cb) {
        const handler = (error, params) => cb(error);
        const internalErrorHandler = (error, params) => cb(new Error(error), params);
        this._rpChatsAPI.on('error', handler);
        this._rpChatsAPI.on('v1/internal-error', internalErrorHandler);
        return () => {
            this._rpChatsAPI.removeListener('error', handler);
            this._rpChatsAPI.removeListener('v1/internal-error', internalErrorHandler);
        };
    }
    chats(params) {
        return this._rpChatsAPI.chats(params);
    }
    chatsDescribe(chatId, params) {
        return this._rpChatsAPI.chatsDescribe(chatId, params);
    }
    chatsMembers(chatId, params) {
        return this._rpChatsAPI.chatsMembers(chatId, params);
    }
    chatsMembersEdit(chatId, membersToAdd, membersToRemove, params) {
        return this._rpChatsAPI.chatsMembersEdit(chatId, membersToAdd, membersToRemove, params);
    }
    chatsNew(newChat, params) {
        return this._rpChatsAPI.chatsNew(newChat, params);
    }
    chatsEdit(editChat, params) {
        return this._rpChatsAPI.chatsEdit(editChat, params);
    }
    chatsDelete(deleteChat, params) {
        return this._rpChatsAPI.chatsDelete(deleteChat, params);
    }
    channels(params) {
        return this._rpChatsAPI.channels(params);
    }
    channelsNew(newChannel, params) {
        return this._rpChatsAPI.channelsNew(newChannel, params);
    }
    channelsDescribe(channelId, params) {
        return this._rpChatsAPI.channelsDescribe(channelId, params);
    }
    channelsMembers(channelId, params) {
        return this._rpChatsAPI.channelsMembers(channelId, params);
    }
    channelsMembersEdit(channelId, membersToAdd, membersToRemove, params) {
        return this._rpChatsAPI.channelsMembersEdit(channelId, membersToAdd, membersToRemove, params);
    }
    channelsEdit(editChannel, params) {
        return this._rpChatsAPI.channelsEdit(editChannel, params);
    }
    channelsDelete(deleteChannel, params) {
        return this._rpChatsAPI.channelsDelete(deleteChannel, params);
    }
    channelsRead(request, params) {
        return this._rpChatsAPI.channelsRead(request, params);
    }
    channelsUnread(params) {
        return this._rpChatsAPI.channelsUnread(params);
    }
    channelsLeave(leaveChannel, params) {
        return this._rpChatsAPI.channelsLeave(leaveChannel, params);
    }
    messages(request, params) {
        return this._rpChatsAPI.messages(request);
    }
    messagesNew(newMessage, params) {
        return this._rpChatsAPI.messagesNew(newMessage, params);
    }
    messagesEdit(editMessage, params) {
        return this._rpChatsAPI.messagesEdit(editMessage, params);
    }
    messagesDelete(deleteMessage, params) {
        return this._rpChatsAPI.messagesDelete(deleteMessage, params);
    }
    onChats(cb, params = { version: 'v1' }) {
        const handler = (chats, params) => cb(chats, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/chats', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/chats', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChatsDescribe(cb, params = { version: 'v1' }) {
        const handler = (chat, params) => cb(chat, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/chats/describe', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/chats/describe', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChatsMembers(cb, params = { version: 'v1' }) {
        const handler = (members, chatId, params) => cb(members, chatId, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/chats/members', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/chats/members', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChatsNew(cb, params = { version: 'v1' }) {
        const handler = (chat, params) => cb(chat, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/chats/new', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/chats/new', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChatsEdit(cb, params = { version: 'v1' }) {
        const handler = (chat, params) => cb(chat, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/chats/edit', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/chats/edit', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChatsDelete(cb, params = { version: 'v1' }) {
        const handler = (chat, params) => cb(chat, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/chats/delete', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/chats/delete', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannels(cb, params = { version: 'v1' }) {
        const handler = (channels, params) => cb(channels, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannelsDescribe(cb, params = { version: 'v1' }) {
        const handler = (channel, params) => cb(channel, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels/describe', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels/describe', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannelsMembers(cb, params = { version: 'v1' }) {
        const handler = (members, channelId, params) => cb(members, channelId, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels/members', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels/members', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannelsNew(cb, params = { version: 'v1' }) {
        const handler = (channel, params) => cb(channel, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels/new', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels/new', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannelsEdit(cb, params = { version: 'v1' }) {
        const handler = (channel, params) => cb(channel, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels/edit', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels/edit', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannelsDelete(cb, params = { version: 'v1' }) {
        const handler = (channel, params) => cb(channel, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels/delete', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels/delete', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannelsRead(cb, params = { version: 'v1' }) {
        const handler = (response, params) => cb(response, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels/read', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels/read', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannelsUnread(cb, params = { version: 'v1' }) {
        const handler = (response, params) => cb(response, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels/unread', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels/unread', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onChannelsLeave(cb, params = { version: 'v1' }) {
        const handler = (channel, userId, params) => cb(channel, userId, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/channels/leave', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/channels/leave', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onMessages(cb, params = { version: 'v1' }) {
        const handler = (messages, page, params) => cb(messages, page, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/messages', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/messages', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onMessagesNew(cb, params = { version: 'v1' }) {
        const handler = (message, params) => cb(message, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/messages/new', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/messages/new', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onMessagesEdit(cb, params = { version: 'v1' }) {
        const handler = (message, params) => cb(message, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/messages/edit', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/messages/edit', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    onMessagesDelete(cb, params = { version: 'v1' }) {
        const handler = (message, params) => cb(message, params);
        switch (params.version) {
            case 'v1':
                this._rpChatsAPI.on('v1/messages/delete', handler);
                return () => {
                    this._rpChatsAPI.removeListener('v1/messages/delete', handler);
                };
            default:
                assert(false, 'Invalid version');
                return null;
        }
    }
    chatsAsync(params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.chats(params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('chatsAsync'));
            }, params.timeout || 5000);
            const cancelFunc = this.onChats((chats, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(chats);
                }
            }, params);
        });
    }
    chatsDescribeAsync(chatId, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.chatsDescribe(chatId);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('chatsDescribeAsync'));
            }, params.timeout);
            const cancelFunc = this.onChatsDescribe((chat, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(chat);
                }
            }, params);
        });
    }
    chatsMembersAsync(chatId, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.chatsMembers(chatId);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('chatsMembersAsync'));
            }, params.timeout);
            const cancelFunc = this.onChatsMembers((members, chatId, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve({ chatId, members });
                }
            }, params);
        });
    }
    chatsNewAsync(newChat, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.chatsNew(newChat, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('chatsNewAsync'));
            }, params.timeout);
            const cancelFunc = this.onChatsNew((chat, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(chat);
                }
            }, params);
        });
    }
    chatsEditAsync(editChat, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.chatsEdit(editChat, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('chatsEditAsync'));
            }, params.timeout);
            const cancelFunc = this.onChatsEdit((chat, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(chat);
                }
            }, params);
        });
    }
    chatsDeleteAsync(deleteChat, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.chatsDelete(deleteChat, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('chatsDeleteAsync'));
            }, params.timeout);
            const cancelFunc = this.onChatsDelete((chat, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(chat);
                }
            }, params);
        });
    }
    channelsAsync(params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channels(params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('channelsAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannels((channels, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(channels);
                }
            }, params);
        });
    }
    channelsDescribeAsync(channelId, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channelsDescribe(channelId);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('channelsDescribeAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannelsDescribe((channel, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(channel);
                }
            }, params);
        });
    }
    channelsMembersAsync(channelId, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channelsMembers(channelId);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('channelsMembersAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannelsMembers((members, channelId, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve({ channelId, members });
                }
            }, params);
        });
    }
    channelsNewAsync(newChannel, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channelsNew(newChannel, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('channelsNewAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannelsNew((channel, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(channel);
                }
            }, params);
        });
    }
    channelsEditAsync(editChannel, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channelsEdit(editChannel, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('channelsEditAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannelsEdit((channel, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(channel);
                }
            }, params);
        });
    }
    channelsDeleteAsync(deleteChannel, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channelsDelete(deleteChannel, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('channelsDeleteAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannelsDelete((channel, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(channel);
                }
            }, params);
        });
    }
    channelsReadAsync(request, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channelsRead(request, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('channelsReadAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannelsRead((response, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(response);
                }
            }, params);
        });
    }
    channelsUnreadAsync(params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channelsUnread(params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('chatsCountersAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannelsUnread((response, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(response);
                }
            }, params);
        });
    }
    channelsLeaveAsync(leaveChannel, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.channelsLeave(leaveChannel, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('channelsLeaveAsync'));
            }, params.timeout);
            const cancelFunc = this.onChannelsLeave((channel, userId, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve({ channel, userId });
                }
            }, params);
        });
    }
    messagesAsync(request, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.messages(request, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('messagesAsync'));
            }, params.timeout);
            const cancelFunc = this.onMessages((messages, page, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve({ messages, page });
                }
            }, params);
        });
    }
    messagesNewAsync(newMessage, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.messagesNew(newMessage, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('messagesNewAsync'));
            }, params.timeout);
            const cancelFunc = this.onMessagesNew((message, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(message);
                }
            }, params);
        });
    }
    messagesEditAsync(editMessage, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.messagesEdit(editMessage, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('messagesEditAsync'));
            }, params.timeout);
            const cancelFunc = this.onMessagesEdit((message, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(message);
                }
            }, params);
        });
    }
    messagesDeleteAsync(deleteMessage, params = { version: 'v1', timeout: RPChats.ASYNC_TIMEOUT_MS }) {
        return new Promise((resolve, reject) => {
            const messageId = this.messagesDelete(deleteMessage, params);
            const timeout = setTimeout(() => {
                cancelFunc();
                return reject(RPChats.ASYNC_TIMEOUT_ERROR('messagesDeleteAsync'));
            }, params.timeout);
            const cancelFunc = this.onMessagesDelete((message, params) => {
                if (params.messageId === messageId) {
                    clearTimeout(timeout);
                    return resolve(message);
                }
            }, params);
        });
    }
}
RPChats.ASYNC_TIMEOUT_MS = 5 * 60 * 1000;
RPChats.ASYNC_TIMEOUT_ERROR = (method) => new Error(`RPChats timeout error for ${method}`);
export { RPChats };
